import React from 'react';

import { useFeatureFlags } from 'src/context';
import { SettingsCard } from 'src/features/settings/layout';
import { useAppSelector } from 'src/hooks/useStore';
import { LoadingWrapper } from 'src/legacy/components/Loading';
import { StripeConnectForm } from 'src/legacy/components/StripeConnectForm';

export const BankingPage: React.FC = () => {
  const isLoading = useAppSelector((state) => state.settings.loading);
  const { EnableNewSettings } = useFeatureFlags();

  return (
    <LoadingWrapper isLoading={isLoading} hideContentWhileLoading>
      {EnableNewSettings ? (
        <SettingsCard layout="fields">
          <StripeConnectForm />
        </SettingsCard>
      ) : (
        <StripeConnectForm />
      )}
    </LoadingWrapper>
  );
};
